/* global getElementOffset, qs, getAncestor, getElementByName, getLocalDateTime */

var _EVENT_ADDION = [];

document.addEventListener("readystatechange", function(e) {
    switch (this.readyState) {
        case "interactive":
        case "complete":
            initCalendar();
    }
});

function initCalendar(eWatcher) {
    var ajaxLoading = false;
    var calendars = document.getElementsByClassName("calendar");
    var calData = {};
    var calPopup;
    var calResvForm;
    var calCurrId;
    var roomFilter = qs(".calendar-filter-room");
    var loopProof = 9999;
    
    // Initiate
    forEach(calendars, build);
    if (roomFilter) {
        if (_EVENT_ADDION.indexOf(roomFilter) === -1) {
            roomFilter.addEventListener("change", filter);
            _EVENT_ADDION.push(roomFilter);
        }
    }
    
    function build(el) {
        var calendar = el || this,
            cid = "c" + randomIdNumber();
        
        // Check if this calendar has already been built
        if (calendar.hasAttribute("data-initiated")) return false;
        
        calendar.setAttribute("data-initiated", "true");
        calendar.setAttribute("data-id", cid);
        calData[cid] = {
            startDate: getDateObject(calendar.getAttribute("data-start")),
            endDate: getDateObject(calendar.getAttribute("data-end")),
            today: getDateObject(calendar.getAttribute("data-now")),
            minHours: parseFloat(calendar.getAttribute("data-min")) || 1,
            divisor: parseFloat(calendar.getAttribute("data-divisor")) || 1,
            filteredId: qs(".calendar-filter-room", calendar.parentElement).value,
            myId: calendar.getAttribute("data-my-id"),
            myEmail: calendar.getAttribute("data-my-email")
        };
        
        $(calendar).on("click", ".calendar-nav.prev", loadPrev)
                .on("click", ".calendar-nav.next", loadNext)
                .on("click", ".calendar-time-select", popIn)
                .on("click", ".popup-close-btn", popOut);
        
        ajaxReservations(calendar);
    }
    
    function getDateObject(str) {
        // Fix the bug Invalid Date on Safari when the date string is "2018-01-02 00:00:00"
        return new Date(str.replace(" ", "T"));
    }
    function getUniversalTime(date) {
        var t = getLocalTime(date),
            h = parseInt(t.substr(0, 2)) - date.getTimezoneOffset() / 60;
    
        return h + t.substr(2);
    }
    
    function filter(e) {
        var calendar = getAncestor(this, "calendar-top-bar").nextElementSibling,
            cid = calendar.getAttribute("data-id");
        
        calData[cid].filteredId = this.value;
        popOut({delegateTarget: calendar});
        displayFilteredRoom(calendar);
    }
    function displayFilteredRoom(calendar) {
        var pid = calData[calendar.getAttribute("data-id")].filteredId;
        
        forEach(qsa(".calendar-reserved-block", calendar), function(el) {
            if (el.getAttribute("data-id") === pid || pid === "") {
                removeClass(el, "blurred");
            } else {
                addClass(el, "blurred");
            }
        });
    }
    
    function loadPrev(e) {
        var calendar = e.delegateTarget,
            cid = calendar.getAttribute("data-id");
    
        update(calendar, nextDate(calData[cid].startDate, -7, true), 
                nextDate(calData[cid].startDate, -1, true));
    }
    function loadNext(e) {
        var calendar = e.delegateTarget,
            cid = calendar.getAttribute("data-id");
    
        update(calendar, nextDate(calData[cid].startDate, 7, true), 
                nextDate(calData[cid].startDate, 13, true));
    }
    function update(calendar, start, end) {
        var cid = calendar.getAttribute("data-id"),
            curYear = calData[cid].today.getFullYear(),
            elSM = qs(".calendar-month.start", calendar),
            elSY = qs(".calendar-year.start", calendar),
            elEY = qs(".calendar-year.end", calendar),
            dayColumns = qsa(".calendar-column", calendar),
            columnDate;
        
        calData[cid].startDate = start;
        calData[cid].endDate = end;
        calendar.setAttribute("data-start", getLocalDateTime(start));
        calendar.setAttribute("data-end", getLocalDateTime(end));
        
        qs(".calendar-date.start", calendar).innerHTML = formatZeros(start.getDate());
        elSM.innerHTML = getMonthName(start.getMonth());
        elSM.style.display = start.getMonth() === end.getMonth() ? "none" : "";
        elSY.innerHTML = start.getFullYear();
        elSY.style.display = start.getFullYear() === end.getFullYear() ? "none" : "";
        
        qs(".calendar-date.end", calendar).innerHTML = formatZeros(end.getDate());
        qs(".calendar-month.end", calendar).innerHTML = getMonthName(end.getMonth());
        elEY.innerHTML = end.getFullYear();
        elEY.style.display = end.getFullYear() === curYear ? "none" : "";
        
        forEach(dayColumns, function(el) {
            if (!columnDate) {
                columnDate = start;
            } else {
                columnDate = nextDate(columnDate, 1, true);
            }
            if (getLocalDate(calData[cid].today) === getLocalDate(columnDate)) {
                addClass(el, "is-today");
            } else if (hasClass(el, "is-today")) {
                removeClass(el, "is-today");
            }
            el.setAttribute("data-date", getLocalDate(columnDate));
            qs(".calendar-day-date", el).innerHTML = formatZeros(columnDate.getDate());
        });
        
        popOut({delegateTarget: calendar});
        
        ajaxReservations(calendar);
    }
    
    function hoverIn(e) { // Used on calendar-body
        e.stopPropagation();
        var target = hasClass(e.target, "calendar-time-select") ? e.target 
                : getAncestor(e.target, "calendar-time-select");
                
        if (!target) return false;
        
        var cell = target.children[0],
            pos = $(cell).offset(),
            hoverEl = qs(".calendar-active-cella", getAncestor(this, "calendar"));
            
        if (!hasClass(hoverEl, "active")) {
            hoverEl.style.top = pos.top + "px";
            hoverEl.style.left = pos.left + "px";
            hoverEl.style.width = cell.clientWidth + "px";
            hoverEl.style.height = cell.clientHeight + "px";
        }
        addClass(hoverEl, "hover");
    }
    function hoverOut(e) { // Used on calendar-body
        removeClass(qs(".calendar-active-cella", getAncestor(this, "calendar")), "hover");
    }
    
    // This method responds to the click event on the calendar
    function popIn(e) {
        var calendar = e.delegateTarget,
            cid = calendar.getAttribute("data-id");
    
        // Set the current popup and form in this calendar
        calPopup = qs(".calendar-reserve-popup", calendar);
        calResvForm = qs("form", calPopup);
        calCurrId = cid;
        
        // Inititate the actions in the form once
        if (!calData[cid].eventsBound) {
            bindEventsInPopup();
            calData[cid].eventsBound = true;
        }
    
        var hoverEl = qs(".calendar-active-cella", calendar),
            cell = qs(".calendar-cell-inner", this),
            startHour = parseFloat(this.getAttribute("data-time")),
            endHour = startHour + calData[cid].minHours,
            startDay = parseInt(this.getAttribute("data-day")),
            percHour = calData[cid].divisor,
            minHoursDelta = calData[cid].minHours / percHour - 1,
            pid = calData[cid].filteredId,
            reserveOptions = calResvForm.elements,
            endHourLimit = parseFloat(reserveOptions.namedItem("endTime").lastElementChild.value),
//#DEPRECATED            selectable = checkSelectableOptions.call(this, calendar, pid, reserveOptions),
            props = {};
    
//#DEPRECATED        if (!selectable) return; // Reserving time is already taken, stop popup

        // Check if the selected cell is within the reservable limit, such as
        // clicking on the last cell
        if (endHour > endHourLimit && loopProof > 0) {
            loopProof--;
            return popIn.call(qs(".ccdt-" + startDay + "-" + ((endHourLimit - calData[cid].minHours) * 100), calendar).children[0], e);
        }
        // Reset loop proofing
        loopProof = 9999;
        
        // Assign dimension properties
        props.offset = getElementOffset(cell, calendar);
        props.cellW = cell.clientWidth;
        props.cellH = cell.clientHeight + cell.parentElement.clientHeight * minHoursDelta + minHoursDelta;
        props.calendarW = calendar.offsetWidth - 1;
        
        // Update the cells and popup
        if (pid !== "" && !hasClass(calPopup, "active")) {
            changeSelectValue(reserveOptions.namedItem("productId"), pid);
        }
        changeSelectValue(reserveOptions.namedItem("startTime"), startHour);
        changeSelectValue(reserveOptions.namedItem("endTime"), endHour);
        
        reserveOptions.namedItem("startDate").value = reserveOptions.namedItem("endDate").value = getAncestor(this, "calendar-column").getAttribute("data-date");
        reserveOptions.namedItem("chosenDay").value = startDay;
        
        // enableSelect(reserveOptions.namedItem("startTime"));
        // enableSelect(reserveOptions.namedItem("endTime"));
        reserveOptions.namedItem("allDay").checked = false;
        reserveOptions.namedItem("allNight").checked = false;
        
        forEach(qsa(".calendar-time-select.active", calendar), function(el) {
            removeClass(el, "active");
        });
        addClass(hoverEl, "active");
        addClass(calPopup, "active");
        // Active text labels inside the cell
        var delta = minHoursDelta * percHour;
        while (delta >= 0) {
            addClass(qs(".ccdt-" + startDay + "-" + ((startHour + delta) * 100), calendar).children[0], "active");
            delta -= 0.5;
        }
        // Check reservable or not to add to cart
        checkReservableTime();
        // Update total price
        setPrice();
        
        hoverEl.style.top = props.offset.top + "px";
        hoverEl.style.left = (100 * props.offset.left / props.calendarW) + "%";
        hoverEl.style.width = (100 * props.cellW / props.calendarW) + "%";
        hoverEl.style.height = props.cellH + "px";
        // To prevent weird movement of the hover, its transition is set to be instant
        hoverEl.style.transitionDuration = "0s";
        setTimeout(function() {
            hoverEl.style.transitionDuration = "";
        }, 200);
        
        props.popupW = calPopup.offsetWidth + 15;
        props.popupH = calPopup.offsetHeight;
        var offMargin = 0;
        // Check if the popup is out of the window, we reposition it to appear 
        // within the visible canvas
        if (getElementOffset(cell).top + props.popupH >= qs("body").offsetHeight) {
            offMargin = props.popupH - props.cellH;
            addClass(calPopup, "bottom");
        } else {
            removeClass(calPopup, "bottom");
        }
        calPopup.style.top = props.offset.top - offMargin + "px";
        if (props.popupW + props.offset.left + props.cellW > props.calendarW) {
            addClass(calPopup, "east");
            calPopup.style.left = (100 * (props.offset.left - props.popupW) / props.calendarW) + "%";
        } else {
            removeClass(calPopup, "east");
            calPopup.style.left = (100 * (props.offset.left + this.clientWidth) / props.calendarW) + "%";
        }
    }
    function popOut(e) {
        var calendar = e.delegateTarget,
            hoverEl = qs(".calendar-active-cella", calendar);
        
        forEach(qsa(".calendar-time-select.active", calendar), function(el) {
            removeClass(el, "active");
        });
        removeClass(hoverEl, "active");
        removeClass(calPopup, "active");
        
        setTimeout(function() {
            hoverEl.style.height = "";
        }, 400);
    }
    
    function bindEventsInPopup() {
        getElementByName(calResvForm, "productId").addEventListener("change", setPrice);
        getElementByName(calResvForm, "productId").addEventListener("change", checkReservableTime);
        // getElementByName(calResvForm, "productId").addEventListener("change", popOut);
        getElementByName(calResvForm, "startTime").addEventListener("change", updateTime);
        getElementByName(calResvForm, "endTime").addEventListener("change", updateTime);
        getElementByName(calResvForm, "allDay").addEventListener("change", chooseAll);
        getElementByName(calResvForm, "allNight").addEventListener("change", chooseAll);
        qs(".calendar-reserve-btn", calPopup).addEventListener("click", addToCart);
    }
    
    function checkReservableTime() {
        var valid = true,
            startTimeSelect = calResvForm.elements.namedItem("startTime"),
            endTimeSelect = calResvForm.elements.namedItem("endTime"),
            startHour = parseFloat(startTimeSelect.value),
            endHour = parseFloat(endTimeSelect.value),
            productSelect = calResvForm.elements.namedItem("productId"),
            productId = productSelect.value,
            size = productSelect.options[productSelect.selectedIndex].getAttribute("data-size");
        
        forEach(qsa(".calendar-reserved-block", getAncestor(qs(".calendar-time-select.active", qs(".calendar[data-id='" + calCurrId + "']")), "calendar-column")), function(it, index, all) {
            var map = it.getAttribute("data-map").split("-"),
                start = parseFloat(map[0]),
                end = parseFloat(map[1]);
            
            // Verify non-conflict reserved hours
            if ((startHour >= start && startHour < end || endHour > start && endHour <= end || startHour <= start && endHour >= end) && (productId === it.getAttribute("data-id") || size === "3" || it.getAttribute("data-size") === "3")) {
                valid = false;
            }
        });
        
        if (valid) {
            removeClass(qs(".calendar-reserve-btn", calPopup), "disable-reservation");
            addClass(qs(".calendar-reserve-not-valid", calPopup), "none");
        } else {
            addClass(qs(".calendar-reserve-btn", calPopup), "disable-reservation");
            removeClass(qs(".calendar-reserve-not-valid", calPopup), "none");
        }
        
        return valid;
    }
    
    //#DEPRECATED
    function checkSelectableOptions(calendar, pid, inputElems) {
        var cell = this,
            hour = parseFloat(cell.getAttribute("data-time")),
            roomSel = inputElems.namedItem("productId"),
            resvBlocks = qsa(".calendar-reserved-block", getAncestor(cell, "calendar-column")),
            resvIds = [],
            resvFull = false,
            resvSize = 0;
    
        // Look through reservations in this day
        forEach(resvBlocks, function(block) {
            var id = block.getAttribute("data-id"),
                period = block.getAttribute("data-map").split("-"),
                size = parseInt(block.getAttribute("data-size"));
            
            if (hour >= parseFloat(period[0]) && hour < parseFloat(period[1])) {
                // Record the room id where this cell is withing the reserved time
                if (pid === id || !pid) {
                    resvIds.push(id);
                }
                // Reserved room is lounge, all other rooms can't be reserved 
                // at this time
                if (size === 3) {
                    resvFull = true;
                }
                resvSize += size;
            }
        });
        
        var changed = false;
        $(roomSel).removeClass('disabled-select');
        roomSel.disabled = false;
        forEach(roomSel.options, function(opt) {
            // If there is one room reserved, lounge can't be reserved (filter mode)
            if (pid === opt.value && opt.getAttribute("data-size") === "3" && resvSize > 0) {
                resvFull = true;
            }
            if (pid !== "" && pid !== opt.value || resvIds.indexOf(opt.value) > -1 || resvFull || opt.getAttribute("data-size") === "3" && resvSize > 0) {
                // Hide unavailable option
                opt.hidden = true;
                $(roomSel).addClass('disabled-select');
                roomSel.disabled = true;
            } else {
                opt.hidden = false;
                // Change current select that has already taken room to another 
                // available room value
                if (!changed && resvIds.indexOf(roomSel.value) > -1) {
                    changeSelectValue(roomSel, opt.value);
                    changed = true;
                }
            }
        });
        
        return resvIds.indexOf(pid) === -1 && !resvFull;
    }
    
    function setPrice(e, price) {
        var elems = calResvForm.elements,
            productSelect = elems.namedItem("productId"),
            selectedOption = productSelect.options[productSelect.selectedIndex],
            rate = parseFloat(selectedOption.getAttribute("data-price")),
            duration = parseFloat(elems.namedItem("endTime").value) - parseFloat(elems.namedItem("startTime").value),
            total = rate * duration / calData[calCurrId].divisor,
            sp = 0;
            
        if (price) {
            total = price;
        } else if (elems.namedItem("allDay").checked) {
            sp = parseFloat(selectedOption.getAttribute("data-price-day"));
            if (sp > 0) total = sp;
        } else if (elems.namedItem("allNight").checked) {
            sp = parseFloat(selectedOption.getAttribute("data-price-night"));
            if (sp > 0) total = sp;
        }
        qs(".calendar-reserve-subtotal", calResvForm).innerHTML = formatMoney(total);
    }
    
    // This method responds to the time select event on the popup
    function updateTime(e) {
        var calendar = qs(".calendar[data-id='" + calCurrId + "']"),
            day = calResvForm.elements.namedItem("chosenDay").value,
            startTimeSelect = calResvForm.elements.namedItem("startTime"),
            endTimeSelect = calResvForm.elements.namedItem("endTime"),
            startHour = parseFloat(startTimeSelect.value),
            endHour = parseFloat(endTimeSelect.value),
            cbDay = calResvForm.elements.namedItem("allDay"),
            cbNight = calResvForm.elements.namedItem("allNight"),
            percHour = calData[calCurrId].divisor,
            minHours = calData[calCurrId].minHours;
    
        if (this === startTimeSelect) {
            if (startHour >= endHour || endHour - startHour < minHours) {
                endHour = startHour + minHours;
                changeSelectValue(endTimeSelect, endHour);
            }
        } else if (this === endTimeSelect) {
            if (startHour >= endHour || endHour - startHour < minHours) {
                startHour = endHour - minHours;
                changeSelectValue(startTimeSelect, startHour);
            }
        }
        
        var starttoend = startHour + "-" + endHour;
        if (starttoend === cbDay.value && !cbDay.checked) {
            cbDay.checked = true;
            chooseAll.call(cbDay, e);
        } else if (starttoend === cbNight.value && !cbNight.checked) {
            cbNight.checked = true;
            chooseAll.call(cbNight, e);
        }
        
        forEach(qsa(".calendar-time-select.active"), function(el) {
            var h = parseFloat(el.getAttribute("data-time"));
            if (h < startHour || h >= endHour) {
                removeClass(el, "active");
            }
        });
    
        var h = startHour;
        while (h < endHour) {
            addClass(qs(".ccdt-" + day + "-" + (h * 100), calendar).children[0], "active");
            h += percHour;
        }
        // Check reservable or not to add to cart
        checkReservableTime();
        // Update total price
        setPrice();

        var block1 = qs(".ccdt-" + day + "-" + (startHour * 100), calendar).children[0],
            cell1 = block1.children[0],
            hoverEl = qs(".calendar-active-cella", calendar),
            hoursDelta = (endHour - startHour) / percHour - 1,
            selectionHeight = cell1.clientHeight + block1.clientHeight * hoursDelta + hoursDelta,
            offMargin = 0;

        hoverEl.style.top = getElementOffset(cell1, calendar).top + "px";
        hoverEl.style.height = selectionHeight + "px";
        // Check if the popup is out of the window, we reposition it to appear 
        // within the visible canvas
        if (getElementOffset(cell1).top + calPopup.offsetHeight >= qs("body").offsetHeight) {
            offMargin = calPopup.offsetHeight - selectionHeight;
            addClass(calPopup, "bottom");
        } else {
            removeClass(calPopup, "bottom");
        }
        calPopup.style.top = getElementOffset(cell1, calendar).top - offMargin + "px";
    }
    
    function chooseAll(e) {
        var cb = this || e.target,
            range = cb.value.split("-"),
            startTimeSelect = calResvForm.elements.namedItem("startTime"),
            endTimeSelect = calResvForm.elements.namedItem("endTime"),
            cbDay = calResvForm.elements.namedItem("allDay"),
            cbNight = calResvForm.elements.namedItem("allNight");
        
        if (cb.checked) {
            // Only 1 option is allowed at once
            if (cb.name === "allDay") cbNight.checked = false;
            if (cb.name === "allNight") cbDay.checked = false;
            // Disable selects so that it will keep the fixed hour range
            // enableSelect(startTimeSelect, true);
            // enableSelect(endTimeSelect, true);
            // Change select hours according to the range
            if (range[0] !== startTimeSelect.value) {
                changeSelectValue(startTimeSelect, range[0]);
            }
            if (range[1] !== endTimeSelect.value) {
                changeSelectValue(endTimeSelect, range[1]);
            }
        } else {
            if (!cbDay.checked && !cbNight.checked) {
                // enableSelect(startTimeSelect);
                // enableSelect(endTimeSelect);
            }
            changeSelectValue(endTimeSelect, parseFloat(range[0]) + calData[calCurrId].minHours);
        }
        updateTime();
    }
    
    function queryDate(array, prefix) {
        var qa = [];
        switch (array.length) {
            case 6: qa.push(prefix + "Second=" + array[5]);
            case 5: qa.push(prefix + "Minute=" + array[4]);
            case 4: qa.push(prefix + "Hour=" + array[3]);
            case 3: qa.push(prefix + "Day=" + array[2]);
            case 2: qa.push(prefix + "Month=" + array[1]);
            case 1: qa.push(prefix + "Year=" + array[0]);
                break;
        }
        return qa.join("&");
    }
    function splitISODate(isoString) {
        var T = isoString.match(/[T\s]/)[0],
            ad = isoString.split(T)[0].split("-"),
            at = isoString.split(T)[1].split(".")[0].split(":"),
            arr = ad.concat(at);
        
        for (var i = 0; i < arr.length; i++) {
            arr[i] = parseInt(arr[i]);
        }
        arr[1] = arr[1] - 1;
        
        return arr;
    }
    
    function addToCart(e) {
        var elems = calResvForm.elements,
            data = "",
            cartData = "",
            startHour = parseFloat(elems.namedItem("startTime").value),
            endHour = parseFloat(elems.namedItem("endTime").value),
            hrs = endHour - startHour,
            qty = hrs / calData[calCurrId].divisor,
            oStartDate, oEndDate;
        
        if (startHour >= endHour || ajaxLoading || !checkReservableTime()) return false;
        
        var _setDate = function(name, value, hour) {
            // var d = new Date();
            // d.setFullYear(value.split("-")[0]);
            // d.setMonth(parseInt(value.split("-")[1]) - 1);
            // d.setDate(parseInt(value.split("-")[2]));
            // d.setHours(hour);
            // d.setMinutes((hour - Math.floor(hour)) * 60);
            // d.setSeconds(0);
            var year, month,day, hours, minutes, seconds;
            year = parseInt(value.split("-")[0]);
            month = (parseInt(value.split("-")[1]) - 1);
            day = parseInt(value.split("-")[2]);
            hours = hour;
            minutes = (hour - Math.floor(hour)) * 60;
            seconds = 0;
            var d = new Date(year, month, day, hours, minutes, seconds);
            
            data += "&" + queryDate(splitISODate(getLocalDateTime(d)), name);
            data += "&" + name + "=" + value;
            
            return d;
        };
        
        var _process = function(input) {
            switch (input.name) {
                case "":
                case null:
                    break;
                case "startDate":
                    oStartDate = _setDate(input.name, input.value, startHour);
                    break;
                case "endDate":
                    oEndDate = _setDate(input.name, input.value, endHour);
                    break;
                default:
                    if (input.type === "checkbox" && input.checked || input.type !== "checkbox") {
                        data += "&" + input.name + "=" + input.value;
                    }
                    break;
            }
        };
        
        var _complete = function(response) {
            ajaxLoading = false;
            if (response.trim() !== "fail") {
                window.location.reload();
            } else {
                var msg = "Failed to reserve this room.\nReason: ";
                if (response.indexOf(":") > -1) {
                    msg += response.substring(response.indexOf(":") + 1).trim();
                } else {
                    msg += "Unknown";
                }
                alert(msg);
            }
        };
        
        
        ajaxLoading = true;
        forEach(elems, _process);
        data += "&quantity=" + qty;
        
        // Custom name for the rooms
        var roomSel = elems.namedItem("productId");
        var roomOpt = roomSel.options[roomSel.selectedIndex];
//        cartData += "<roominfo>" + roomOpt.text;
        cartData += "<roominfo>";
        cartData += " (" + hrs + " " + l10n("heures", "hours") + " @ ";
        // Regular price is per hours-per-quantity thus divided by the divisor of hours
        var factor = calData[calCurrId].divisor || 1;
        var perHour = parseFloat(roomOpt.getAttribute("data-price")) / factor;
        // All day price is per hour thus divided by hours
        if (elems.namedItem("allDay").checked && roomOpt.getAttribute("data-price-day") !== '0.0') {
            perHour = parseFloat(roomOpt.getAttribute("data-price-day")) / hrs;
        } else if (elems.namedItem("allNight").checked && roomOpt.getAttribute("data-price-night") !== '0.0') {
            perHour = parseFloat(roomOpt.getAttribute("data-price-night")) / hrs;
        }
        cartData += formatMoney(perHour) + "/" + l10n("heure", "hour") + ")";
        cartData += "</roominfo><br/><reservedate>";
        // In-cart date format "2017/01/01 17:00 � 21:00" or "2018/01/01 23:00 au 2018/01/02 02:00"
        cartData += getLocalDateTime(oStartDate).substring(0, 16).replace(/-/g, "/") + " ";
        var eldt = getLocalDateTime(oEndDate).substring(0, 16).replace(/-/g, "/");
        if (endHour > 23) {
            cartData += l10n("au", "to") + " " + eldt.substr(0, 10);
        } else {
            cartData += l10n("&#224;", "to");
        }
        cartData += " " + eldt.substr(11, 5) + "</reservedate>";
        data += "&data=" + encodeURIComponent(cartData);
        
        ajax("/action/paReserve?ajax=true" + data, _complete, true);
    }
    
    function ajaxReservations(calendar) {
        var data = getDataSet(calendar),
            sd = getDateObject(data.start),
            ed = getDateObject(data.end),
            url = "/action/paReserve?categoryId=" + data.cat;
    
        url += "&" + queryDate([sd.getFullYear(), sd.getMonth(), sd.getDate(), sd.getHours(), 0], "startDate");
        url += "&" + queryDate([ed.getFullYear(), ed.getMonth(), ed.getDate(), ed.getHours(), 0], "endDate");
        
        forEach(qsa(".calendar-reservoirs", calendar), function(it, index, all) {
            it.innerHTML = "";
            if (index === all.length - 1) {
                siteAjax(url, unloadReservations, calendar);
            }
        });
    }
    function unloadReservations(response, calendar) {
        if (response === "" || loopProof <= 0) return false; // Nothing to unload

        // Ensure that the calendar element are completely built before injecting the reservations
        if (document.readyState !== "complete" || calendar.clientHeight === 0) {
            loopProof--;
            return window.setTimeout(function () {
                unloadReservations(response, calendar);
            }, 100);
        }
        // Reset loop proofer
        loopProof = 9999;

        var cid = calendar.getAttribute("data-id"),
            list = JSON.parse(response);
        
        list.forEach(function(o) {
            var dateString = o.startDate.substringBefore(" "),
                dateEndString = o.endDate.substringBefore(" "),
                startTime = parseInt(o.startDate.substr(11, 2)) + parseInt(o.startDate.substr(14, 2)) / 60,
                endTime = parseInt(o.endDate.substr(11, 2)) + parseInt(o.endDate.substr(14, 2)) / 60,
                column = qs(".calendar-column[data-date='" + dateString + "']", calendar),
                cell = qs(".calendar-cell[data-time='" + startTime + "']", column),
                ctn = qs(".calendar-reservoirs", column),
                el = document.createElement("DIV"),
                pos = qs(".cci" + o.productId).getAttribute("data-order"),
                timelength = dateString > "2019-03-18" ? o.quantity : o.quantity / calData[cid].divisor;
            
            // Add 24 hours to end time when the reservation ends on the next day
            if (dateEndString > dateString) {
                endTime += 24;
            }
            ctn.append(el);
            el.className = "calendar-reserved-block size-" + o.addTextField1 + "-" + pos;
            if (o.personId && o.personId.toString() === calData[cid].myId || o.email && o.email === calData[cid].myEmail) {
                el.className += " my-reservation";
            }
            el.setAttribute("data-id", o.productId);
            el.setAttribute("data-map", startTime + "-" + endTime + "-" + pos);
            el.setAttribute("data-size", o.addTextField1);
            el.style.top = getElementOffset(cell.children[0], column).top + "px";
            el.style.height = cell.children[0].clientHeight + cell.parentElement.offsetHeight * (timelength - 1) + "px";
            el.style.backgroundColor = o.shortDescription;
        });
        displayFilteredRoom(calendar);
    }
}